import { render, staticRenderFns } from "./RatingChart.vue?vue&type=template&id=c941a76e"
import script from "./RatingChart.vue?vue&type=script&lang=js"
export * from "./RatingChart.vue?vue&type=script&lang=js"
import style0 from "./RatingChart.vue?vue&type=style&index=0&id=c941a76e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports